export * from './ProductDetailsIngredients';
